<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content">
  <div>

    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
        <div class="row">
          <div class="col-md-4 padding-right-0px">
            Embryos In My Store
          </div>
          <div class="col-md-7 padding-right-0px">
            <!--<button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>-->
          </div>
          <div class="col-md-1">
            <button type="button" class="close margin-right-10px" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>




      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">
        <div class="row">

          <div class="col-md-3 bk-color-light2">
            <div class="row margin-top-10">
              <div class="col-md-12">
                <div class=" card card-background-transparent card-height">

                  <div class="row margin-top-10">
                    <div class="col-md-11 text-align-center padding-left-0px" *ngIf="SelectedTreatmentCycle">
                      <img class="img-circle-50 margin-left-10px" [src]="SelectedTreatmentCycle.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                      <!--<img  class="img-circle-50 margin-left-10px" *ngIf="!l.PatientImageFile" src="dummy.jpg">-->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center" *ngIf="SelectedTreatmentCycle">
                      <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{SelectedTreatmentCycle.EggName}}</label>

                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->
                    </div>
                  </div>
                  <div class="row" *ngIf="SelectedTreatmentCycle">
                    <div class="col-md-11  padding-left-0px padding-right-0px text-align-center" *ngIf="SelectedTreatmentCycle.EggSourceType=='DONOR' || SelectedTreatmentCycle.EggSourceType=='Donor'">
                      <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedTreatmentCycle.OwnerName}}) </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center" *ngIf="SelectedTreatmentCycle">
                      <label class="margin-bottom-0px">{{SelectedTreatmentCycle.EggFormattedCode}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 padding-left-0px padding-right-0px text-align-center margin-left-3px" *ngIf="SelectedTreatmentCycle">
                      <label class="margin-bottom-0px">
                        <!--32yrs,Female-->
                        {{SelectedTreatmentCycle.EggAgeYears}},{{SelectedTreatmentCycle.EggGender}}
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <!--<div class="col-md-3">
                      <label>Phone Number:</label>
                    </div>-->
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center margin-left-3px" *ngIf="SelectedTreatmentCycle">
                      <label class="margin-bottom-0px">{{SelectedTreatmentCycle.EggTelephone1}}</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px" *ngIf="SelectedTreatmentCycle">
                    <div class="col-md-12 padding-right-4px padding-left-0px">
                      <div class="card card-background-transparent border-all-1px border-radius-5px">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-left-0px">
                            <div class="col-md-6 text-align-right padding-left-0px">
                              <label class="margin-bottom-0px font-size-12px">Cycle Type</label>
                            </div>:
                            <div class="col-md-5">
                              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{SelectedTreatmentCycle.CycleType}}</label>
                            </div>
                          </div>
                          <div class="row margin-left-0px">
                            <div class="col-md-6 text-align-right">
                              <label class="margin-bottom-0px font-size-12px">Protocol</label>
                            </div>:
                            <div class="col-md-5">
                              <label class=" font-size-12px margin-bottom-0px margin-top-3px display-inherit">{{SelectedTreatmentCycle.ProtocolName}}</label>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>

          <div class="col-md-9">

            <div class="row" *ngIf="TabsView">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px ">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#Currentcycle" data-toggle="tab">Current Cycle</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#Previouscycle" data-toggle="tab">Previous Cycles</a></li>
                      <!--<li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#Forms" data-toggle="tab">Consent Forms</a></li>-->
                    </ul>
                  </div>
                  <div class="card-body padding-all-0px margin-left-10px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="Currentcycle">
                        <div class="row">
                          <div class="col-md-12 padding-left-0px padding-right-0px ">
                            <div class="chatsd product-chart-wrapper product-chat-width-transfer2 agreement-chart-wrapper  padding-lrt overflow-y-scroll " data-ps-id="dfsfsde">
                              <div>
                                <div class="row">
                                  <div class="form-group col-md-12 margin-bottom-5px padding-left-0px">
                                    <div class="row">
                                      <div class="col-md-4 padding-right-0px margin-top-5px text-align-right padding-left-0px">
                                        <label class="margin-bottom-0px">
                                          Select Straw Number :
                                        </label>
                                      </div>
                                      <div class="col-md-3 padding-right-0px padding-left-0px">
                                        <CodeTypeValue CodeType="STNO" id="StrawNumber"
                                                       [(ngModel)]="StrawNumber2" SelectedValue=""
                                                       (keyChange)="dataChanged2(StrawNumber2)"
                                                       name="StrawNumber2" required>



                                        </CodeTypeValue>

                                      </div>
                                    </div>

                                  </div>

                                </div>
                                <div class="row margin-left-0px" *ngIf="length>0">
                                  <div class="col-md-12 padding-left-0px padding-right-0px padding-left-0px">
                                    <div class="chatsd product-chart-wrapper product-chat-width-transfer2 agreement-chart-wrapper ps  padding-lrt overflow-y-scroll " data-ps-id="dfsfsde">

                                      <div class="table-component">
                                        <div class="table-responsive">


                                          <table class="table table-striped margin-left-zero width-100pe">

                                            <thead class="">
                                              <tr>
                                                <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Cycle#</th>
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline padding-left-0px padding-right-0px">DOC &amp; Date  </th>


                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                                <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                                <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->

                                                <th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>


                                              </tr>
                                            </thead>
                                            <tbody class="table-body">

                                              <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesController ; let RowIndex = index ">
                                                <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                                <td class="padding-top-4px padding-bottom-4px text-align-right">{{l.CycleNo}}</td>
                                                <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                                <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">
                                                  <div>[{{l.DOC}}],</div>
                                                  <div class="row margin-left-zero font-size-11px">{{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}</div>
                                                </td>

                                                <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>
                                                <td class="padding-top-4px padding-bottom-4px">{{l.CellStage}}</td>
                                                <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>
                                                <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                                <td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime float-right font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>
                                              </tr>
                                            </tbody>

                                          </table>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                              </div>
                              <div *ngIf="length==0" class="margin-left-10px position-absolute styles-embryos">
                                <label class="margin-bottom-0px color-Assign font-size-18px">No Embryos in Current Cycle</label>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>
                      <div class="tab-pane" id="Previouscycle">
                        <div class="row">
                          <div class="col-md-12 padding-left-0px padding-right-0px">
                            <div class="chatsd product-chart-wrapper product-chat-width-transfer2 agreement-chart-wrapper overflow-y-scroll  padding-lrt" data-ps-id="dfsfsde">
                              <div>
                                <div class="row">
                                  <div class="form-group col-md-12 margin-bottom-5px padding-left-0px">
                                    <div class="row">
                                      <div class="col-md-4 padding-right-0px margin-top-5px text-align-right padding-left-0px">
                                        <label class="margin-bottom-0px">
                                          Select Straw Number :
                                        </label>
                                      </div>
                                      <div class="col-md-3 padding-right-0px padding-left-0px">
                                        <CodeTypeValue CodeType="STNO" id="StrawNumber"
                                                       [(ngModel)]="StrawNumber" SelectedValue=""
                                                       (keyChange)="dataChanged(StrawNumber)"
                                                       name="StrawNumber" required>



                                        </CodeTypeValue>

                                      </div>
                                    </div>

                                  </div>

                                </div>
                                <div class="row margin-left-0px" *ngIf="length2>0">
                                  <div class="col-md-12 padding-left-0px padding-right-0px padding-left-0px">
                                    <div class="chatsd product-chart-wrapper product-chat-width-transfer2 agreement-chart-wrapper ps  padding-lrt overflow-y-scroll " data-ps-id="dfsfsde">

                                      <div class="table-component">
                                        <div class="table-responsive">


                                          <table class="table table-striped margin-left-zero width-100pe">

                                            <thead class="">
                                              <tr>
                                                <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Cycle#</th>
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                                <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline padding-left-0px padding-right-0px">DOC &amp; Date  </th>


                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                                <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                                <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                                <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->

                                                <th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>


                                              </tr>
                                            </thead>
                                            <tbody class="table-body">

                                              <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesControllerByActor ; let RowIndex = index ">
                                                <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                                <td class="padding-top-4px padding-bottom-4px text-align-right">{{l.CycleNo}}</td>
                                                <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                                <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">
                                                  <div>[{{l.DOC}}],</div>
                                                  <div class="row margin-left-zero font-size-11px">{{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}</div>
                                                </td>

                                                <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>
                                                <td class="padding-top-4px padding-bottom-4px">{{l.CellStage}}</td>
                                                <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>
                                                <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                                <td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime float-right font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>
                                              </tr>
                                            </tbody>

                                          </table>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                              <div *ngIf="length2==0" class="margin-left-10px position-absolute styles-embryos">
                                <label class="margin-bottom-0px color-Assign font-size-18px">No Embryos in Previous Cycle</label>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px" *ngIf="EmbryoSelected">
              <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px border-left-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Cycle</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Cyclenumber1">{{Cyclenumber1}}</h4></div>
              </div>
              <div class="col-md-2  text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">DOC</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="DOC1">{{DOC1}}</h4></div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Grade</h4></div>
                <div class="margin-bottom-10px display-inline"><h4 class="margin-bottom-0px display-inline" *ngIf="Grade1new">{{Grade1new}}</h4><h4 class="margin-bottom-0px display-inline" *ngIf="Grade2new">{{Grade2new}}</h4> </div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Count</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Count">{{Count}}</h4></div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Straw#</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="StrawSelected">{{StrawSelected}}</h4></div>
              </div>
              <div class="col-md-1 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Cycle#</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Cycleno">{{Cycleno}}</h4></div>
              </div>
            </div>
            <div class="row margin-left-zero margin-right-0px" *ngIf="SelectedEmbryoDetails">
              <div class="card col-md-12">
                <div class="card-header wh-header padding-top-6px padding-bottom-6px">
                  <div class="row">
                    <div class="col-md-8">
                      <label class="margin-bottom-0px"> Store Locations</label>
                    </div>

                  </div>

                </div>
                <div class="card-body padding-all-0px margin-left-zero">
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-12 padding-right-0px padding-left-0px">
                      <div class="chatsd product-chart-wrapper product-chat-width-transfer agreement-chart-wrapper ps  padding-lrt overflow-y-scroll " data-ps-id="dfsfsde">
                        <div class="table-component margin-bottom-0px">
                          <div class="table-responsive overflow-x-hidden">


                            <table class="table table-striped margin-left-zero">
                              <thead class="">
                                <tr>
                                  <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Count &amp; Cryo Top </th>
                                  <!--<th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Blastomere Count</th>-->
                                  <!--<th class="padding-top-4px padding-bottom-4px  font-size-12px padding-left-6px">Cryo Top</th>-->
                                  <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Cannister</th>
                                  <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Goblet</th>
                                  <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Hexa</th>
                                  <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Viso</th>


                                  <th class="td-well-width-79px padding-top-4px padding-bottom-4px font-size-12px"></th>
                                </tr>
                              </thead>

                              <tbody class="table-body">
                                <tr *ngFor="let l of CurrentIvfCycleEmbryoStorageAreaController">
                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">

                                    <div>[{{l.EmbryoCount}}],</div>
                                    <div class="font-size-11px">{{l.CryoTopColor}}</div>
                                  </td>
                                  <!--<td class="padding-top-0px padding-bottom-0px">
                                    {{l.CryoTopColor}}
                                  </td>-->

                                  <td class="padding-top-0px padding-bottom-0px">
                                    {{l.CanisterNo}}
                                  </td>
                                  <td class="padding-top-0px padding-bottom-0px ">

                                    {{l.Goblet}}
                                    <!--Day{{DOC}}Grade{{1}}-->
                                    <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->

                                  </td>
                                  <td class="padding-top-0px padding-bottom-0px ">




                                    {{l.Hexa}}
                                  </td>
                                  <td class="padding-top-0px padding-bottom-0px ">
                                    {{l.Viso}}
                                  </td>


                                  <td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime float-right font-size-13px margin-right-auto" (click)="SelectPresentstep2(l)">Select</button></td>



                                </tr>

                              </tbody>

                            </table>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-footer padding-top-6px padding-bottom-6px">

                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right margin-left-3px" (click)="activeModal.close('Close click')">Close</button>
                  <button (click)="BackToStep1()" class="btn actions-btn-prime float-right font-size-13px margin-left-auto  float-right margin-left-3px">Back</button>

                </div>
              </div>
            </div>
            <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px" *ngIf="SelectedEmbryoStoreDetails">
              <div class="col-md-2  text-align-center padding-right-0px padding-left-0px border-right-1px border-left-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">DOC &amp; Date</h4></div>
                <div class=""><h4 class="margin-bottom-0px" *ngIf="DOC1">[{{DOC1}}]</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Date3">{{Date3| date:'MMM-dd-yyyy'}}</h4></div>
              </div>
              <div class="col-md-2  text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Canister</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Canisterno">{{Canisterno}}</h4></div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Goblet</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Goblet">{{Goblet}}</h4></div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Hexa</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Hexa">{{Hexa}}</h4> </div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Viso</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Viso">{{Viso}}</h4></div>
              </div>
              <div class="col-md-2 text-align-center padding-right-0px padding-left-0px border-right-1px">
                <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Count</h4></div>
                <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="UsedCount">{{UsedCount}}</h4></div>
              </div>
            </div>
            <div class="row margin-left-0px margin-right-0px margin-top-10" *ngIf="SaveTransfer">
              <div class="col-md-12">
                <form class="form" novalidate="" (ngSubmit)="TransferCompleted()" #f="ngForm">
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Cycle#</label>
                        </div>:

                        <div class="col-md-4">
                          <label class="margin-bottom-0px margin-top-3px" *ngIf="Cycleno">{{Cycleno}}</label>
                          <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                          <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                  maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Straw#</label>
                        </div>:

                        <div class="col-md-4">
                          <label class="margin-bottom-0px margin-top-3px" *ngIf="StrawSelected">{{StrawSelected}}</label>
                          <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                          <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                  maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                        </div>
                      </div>


                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Stored Grade</label>
                        </div>:

                        <div class="col-md-4">
                          <label class="margin-bottom-0px margin-top-3px display-inline" *ngIf="Grade1new">{{Grade1new}}</label><label class="margin-bottom-0px margin-top-3px display-inline" *ngIf="Grade2new">{{Grade2new}}</label>
                          <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                          <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                 name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                  maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 text-align-right">
                          <label for="firstName" class="margin-bottom-0px margin-top-3px"> Current Grade</label>
                        </div>
                        <div class="col-md-4">

                          <CodeTypeValue CodeType="D{{DOC1}}GR1"
                                         id="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade1"
                                         [(ngModel)]="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade1" SelectedValue=""
                                         name="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade1">
                          </CodeTypeValue>


                        </div>
                        <div class="col-md-4" *ngIf="DOC1>4">

                          <CodeTypeValue CodeType="D{{DOC1}}GR2"
                                         id="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade2"
                                         [(ngModel)]="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade2" SelectedValue=""
                                         name="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.Regrade2">
                          </CodeTypeValue>


                        </div>

                      </div>

                    </div>
                  </div>



                  <div class="row">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                      <div class="row">

                        <div class="col-md-3 text-align-right ">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px">
                            Select Embryos
                          </label>

                        </div>
                        <div class="col-md-4 ">
                          <input type="text" class="form-control" placeholder="Embryos"
                                 id="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.UsedCount"
                                 [(ngModel)]="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.UsedCount"
                                 name="CurrentSaveIvfCycleEmbryoTransferredInfoRequest.UsedCount" #Endometrium="ngModel"
                                 maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(CurrentSaveIvfCycleEmbryoTransferredInfoRequest.UsedCount > UsedCount)">(Error:Please Recheck the Selected Embryos)</small>

                        </div>
                        <!--<div class="col-md-3" *ngIf="BeforeEnterInput">
                          <label>({{FrozenCount}} Remaining)</label>
                        </div>
                        <div class="col-md-3" *ngIf="AfterEnterInput">
                          <label>({{FrozenCount-CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount }} Remaining)</label>
                        </div>-->

                      </div>


                    </div>
                  </div>
                  <div class="row margin-right-0px margin-top-10">
                    <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-left-auto  float-right">Transfer</button>
                    <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-auto font-size-13px float-right margin-left-3px" (click)="activeModal.close('Close click')">Cancel</button>
                  </div>
                </form>
              </div>
            </div>
          </div>


        </div>



      </div>
      <!--<div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
      </div>-->
    </div>

  </div>
</div>
<!--<div class="modal-signup modal-content" *ngIf="Select">
  <div>
    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


        <div class="card-header wh-header padding-bottom-0px padding-right-5px padding-left-10px">
          <div class="row">
            <div class="col-md-4 padding-right-0px">
              Edit
            </div>
            <div class="col-md-7 padding-right-0px">
              <button type="submit" class="btn font-size-13px actions-btn-prime float-right">Save</button>
            </div>
            <div class="col-md-1">
              <button type="button" class="close margin-right-10px" data-dismiss="modal"
                      (click)="activeModal.dismiss('Cross click')"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>




        </div>

        <div class="modal-body padding-top-0px">
          <div class="row border-top-1px border-bottom-1px">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Date: {{Date| date:'MMM-dd-yyyy'}}</label></div>
            </div>
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">Cycle Number : {{Cyclenumber}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">DOC : {{DOC}}</label></div>
            </div>
          </div>


          <div class="row my-profile-form margin-top-10">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"><span>*</span> Embryo Count </label>
                </div>:
                <div class="col-md-3">


                  <label>{{Embryocount}}</label>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==2 || DOC==3 || DOC==4 "> Cell Stage </label>
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-5px" *ngIf="DOC==5 || DOC==6 "> Stage </label>
                </div>
                <div class="col-md-3">

                  <CodeTypeValue CodeType="IVFCS" id="CurrentSaveEmbryoStoreInfoRequest.CellStage"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.CellStage" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.CellStage"
                                 name="CurrentSaveEmbryoStoreInfoRequest.CellStage" required>

                  </CodeTypeValue>

                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Grade </label>
                </div>:
                <div class="col-md-3">

                  <label>{{Grade1}}{{Grade2}}</label>


                </div>

              </div>

            </div>
          </div>

          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> ReGrade </label>
                </div>
                <div class="col-md-3">

                  <CodeTypeValue CodeType="D{{DOC}}GR1" id="CurrentSaveEmbryoStoreInfoRequest.ReGrade"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.ReGrade" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.ReGrade"
                                 name="CurrentSaveEmbryoStoreInfoRequest.ReGrade" required>

                  </CodeTypeValue>

                </div>
                <div class="col-md-3" *ngIf="DOC>4">
                  <CodeTypeValue CodeType="D{{DOC}}GR2" id="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"
                                 [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.ReGrade2" SelectedValue="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"
                                 name="CurrentSaveEmbryoStoreInfoRequest.ReGrade2"></CodeTypeValue>

                </div>

              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px">Transfer Count </label>
                </div>
                <div class="col-md-3">

                  <input type="number" class="form-control" placeholder="Transfer Count"
                         id="CurrentSaveEmbryoStoreInfoRequest.Count"
                         [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.Count" required
                         name="CurrentSaveEmbryoStoreInfoRequest.Count" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />


                </div>


              </div>

            </div>
          </div>
          <div class="row my-profile-form">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-5 text-align-right">
                  <label for="firstName" class="label-size margin-bottom-0px margin-top-3px"> Remarks </label>
                </div>
                <div class="col-md-3">
                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                            name="CurrentSaveEmbryoStoreInfoRequest.Remarks"
                            [(ngModel)]="CurrentSaveEmbryoStoreInfoRequest.Remarks" required minlength="1" maxlength="100"
                            #addconcerns_text="ngModel"></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                </div>


              </div>

            </div>
          </div>


        </div>

      </div>
    </form>
  </div>
</div>-->
